import React, { useState, useEffect } from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle, faSpinner, faCheckCircle } from '@fortawesome/pro-light-svg-icons';
import { STRIPE_STATUS_REQUIRES_CAPTURE, STRIPE_STATUS_SUCCEEDED, STRIPE_STATUS_PROCESSING, STRIPE_STATUS_REQUIRES_PAYMENT_METHOD } from 'configs/constants';
import { getText } from 'helpers/app/getText';

const PaymentStatus = () => {
  const stripe = useStripe();
  const [message1, setMessage1] = useState('');
  const [message2, setMessage2] = useState('');
  const [message3, setMessage3] = useState('');
  const [status, setStatus] = useState('');

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get('payment_intent_client_secret');

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      setStatus(paymentIntent.status);
      switch (paymentIntent.status) {
        case STRIPE_STATUS_SUCCEEDED:
          setMessage1(getText('main:STRIPE_SUCCESS_MSG1'));
          setMessage2(getText('main:STRIPE_SUCCESS_MSG2'));
          setMessage3(getText('main:STRIPE_SUCCESS_MSG3'));
          break;

        case STRIPE_STATUS_REQUIRES_CAPTURE:
          setMessage1(getText('main:STRIPE_SUCCESS_MSG1'));
          setMessage2(getText('main:STRIPE_SUCCESS_MSG2'));
          setMessage3(getText('main:STRIPE_SUCCESS_MSG3'));
          break;

        case STRIPE_STATUS_PROCESSING:
          setMessage1(getText('main:STRIPE_PROCESSING_MSG'));
          break;

        case STRIPE_STATUS_REQUIRES_PAYMENT_METHOD:
          setMessage1(getText('main:STRIPE_PAYMENT_FAILED_MSG'));
          break;

        default:
          setMessage1(getText('main:STRIPE_ERROR_MSG'));
          break;
      }
    });
  }, [stripe]);

  return (
    <div className="flex-1 overflow-y-auto p-3 text-center place-items-center grid">
      <div className="max-w-sm rounded overflow-hidden status-box">
        <h6>{message1}</h6>
        {message2.length > 0 && <h6>{message2}</h6>}
        {message3.length > 0 && <h6 className="mt-20">{message3}</h6>}
        <hr />
        {status.length > 0 && status !== STRIPE_STATUS_REQUIRES_CAPTURE && status !== STRIPE_STATUS_SUCCEEDED && status !== STRIPE_STATUS_PROCESSING && status !== STRIPE_STATUS_REQUIRES_PAYMENT_METHOD && <FontAwesomeIcon icon={faTimesCircle} className="failed-check" size="6x"></FontAwesomeIcon>}
        {status === STRIPE_STATUS_SUCCEEDED || (status === STRIPE_STATUS_REQUIRES_CAPTURE && <FontAwesomeIcon icon={faCheckCircle} className="success-check" size="6x"></FontAwesomeIcon>)}
        {status === STRIPE_STATUS_PROCESSING && <FontAwesomeIcon icon={faSpinner} className="success-check" size="6x"></FontAwesomeIcon>}
        {status === STRIPE_STATUS_REQUIRES_PAYMENT_METHOD && <FontAwesomeIcon icon={faTimesCircle} className="success-check" size="6x"></FontAwesomeIcon>}
        <hr />
      </div>
    </div>
  );
};

export default PaymentStatus;
